/**
 * Sales Agent settings, as the API serves them and the Settings tab uses them: the settings that
 * apply to the selected brand, its own or the account's, with every field always filled in.
 */

/** The longest disclaimer the API accepts. */
export const DISCLAIMER_MAX_LENGTH = 2000;

/** The longest conversation starter the API accepts. There is no limit on how many. */
export const STARTER_QUESTION_MAX_LENGTH = 80;

/** The longest subtitle the API accepts, and what the chat shows when it is left empty. */
export const SUBTITLE_MAX_LENGTH = 60;
export const DEFAULT_SUBTITLE = 'Your AI Assistant';

export interface Disclaimer {
	/** True: the shopper must agree before sending a message. False: footer link only. */
	enabled: boolean;
	/** Markdown subset: **bold**, *italic* and [links](https://…). */
	text: string;
}

export interface SalesAgentSettings {
	/** Controls automatic order syncing for Performance only. */
	performanceEnabled?: boolean;
	buId: number | null;
	/** The selected brand has no settings of its own; these are the account's. */
	inherited: boolean;
	disclaimer: Disclaimer;
	/** Shown under the brand name in the chat. Empty: the chat shows DEFAULT_SUBTITLE. */
	subtitle: string;
	/** Shown as tappable pills when a chat starts; set here, not generated. */
	starterQuestions: string[];
	updatedAt: string | null;
}

/** Any part can be saved on its own; the others keep their values. The tab sends all of them. */
export interface UpdateSalesAgentSettingsRequestDto {
	performanceEnabled?: boolean;
	disclaimer?: Disclaimer;
	subtitle?: string;
	starterQuestions?: string[];
}
